"use client"

import { createContext, useContext, useState, type ReactNode } from "react"

type ModalContextType = {
  isRequestFormOpen: boolean
  openRequestForm: () => void
  closeRequestForm: () => void
}

const ModalContext = createContext<ModalContextType | undefined>(undefined)

export function ModalProvider({ children }: { children: ReactNode }) {
  const [isRequestFormOpen, setIsRequestFormOpen] = useState(false)

  const openRequestForm = () => {
    setIsRequestFormOpen(true)
  }

  const closeRequestForm = () => {
    setIsRequestFormOpen(false)
  }

  return (
    <ModalContext.Provider value={{ isRequestFormOpen, openRequestForm, closeRequestForm }}>
      {children}
    </ModalContext.Provider>
  )
}

export function useModal() {
  const context = useContext(ModalContext)
  if (context === undefined) {
    throw new Error("useModal must be used within a ModalProvider")
  }
  return context
}
